import { CreateDatasetPopover } from "@/shared/components/CreateDatasetButton/CreateDatasetPopover";
import { CreateEntityButton } from "@/shared/components/CreateEntityButton";
import { usePopupState } from "@/shared/hooks/usePopupState";

interface CreateDatasetPopoverButtonProps {
  /**
   * Trigger style: the solid CTA in the page toolbar, or the neutral outlined
   * one the empty state shows. Passed straight through to {@link RobotoButton}.
   * @default "primary"
   */
  variant?: "primary" | "secondary";
  /**
   * Where the create-dataset form opens relative to the button. The toolbar
   * sits at the right edge, so the form's right edge aligns with the button's
   * and it opens leftward, staying on screen; the empty state is centered, so
   * the form centers under it.
   * @default "right"
   */
  popoverAlign?: "right" | "center";
}

/**
 * "New dataset" action for the datasets page. Opens the existing
 * create-dataset popover — which owns the form, submission, and post-create
 * navigation — instead of routing to `/datasets/create`.
 */
export function CreateDatasetPopoverButton({
  variant = "primary",
  popoverAlign = "right",
}: CreateDatasetPopoverButtonProps) {
  const popup = usePopupState();

  return (
    <>
      <CreateEntityButton
        entity="dataset"
        variant={variant}
        onClick={(event) => popup.open({ anchorEl: event.currentTarget })}
      />
      <CreateDatasetPopover
        anchorEl={popup.anchor}
        handleClose={popup.close}
        anchorOrigin={{ vertical: "bottom", horizontal: popoverAlign }}
        transformOrigin={{ vertical: -15, horizontal: popoverAlign }}
      />
    </>
  );
}
